import { Component, OnInit, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-control-panel",
  templateUrl: "./control-panel-widget.component.html",
  styleUrls: ["./control-panel-widget.component.css"],
})
export class ControlPanelWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  
  history: number = 50;
  from: string;
  to: string;
  public c: any;

  public rangeLimiter: any;

  private colours: string[];

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetBeforeInit() {
    this.c = <any>this.config;
  }

  widgetAfterInit() {
    if (this.c && this.c.tableDetailList){
      for (let c of this.c.tableDetailList){
        c.colour = "#d1dade";
      }
    }
    this.loadPtz();
  }

  public isNaN(val){
    return typeof val != 'number';
  }

  refresh() {
    this.ngOnInit();
  }

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  widgetLiveDataLoaded(s: any) {
    //var item = this.c.tableDetailList.find(d => d.uri == s.uri) as any;
    var item = <any>this.c.tableDetailList[s.index];
    if (item == null){
      item = this.c.tableDetailList.find(d => d.uri == s.uri) as any;
    }
    item.value = Math.round(s.point.value*1000)/1000;
    item.colour = null;
    item.name = s.point.value;
    var zoneColours = item.zoneColours == null || item.zoneColours.length == 0 ? this.c.zoneColours : item.zoneColours;
    if (zoneColours){
      for (let r of zoneColours){
        if (item.value >= r.min && item.value <= r.max){
          item.colour = r.colour;
        }
      }
    }
    if (item.values == null){
      item.values = this.tidyHistory(null);
    }

    var values = [...item.values];
    if (values.length > this.history){
      values.shift();  
    }
    values.push(item.value);
    item.values = this.tidyHistory(values);
  }

  widgetDataLoaded(s: SharedSeries) {
    //var item = this.c.tableDetailList.find(d => d.uri == s.uri);
    var item = <any>this.c.tableDetailList[s.index];
    var values = this.tidyHistory(null);
    if (s.values.length > 0){
      // no more that 3 decimal places allowed
      item.value = Math.round(s.values[s.values.length - 1].value*1000)/1000;
      //item.colour = "#d1dade";
      var colour = null;
      var zoneColours = item.zoneColours == null || item.zoneColours.length == 0 ? this.c.zoneColours : item.zoneColours;
      if (zoneColours){
        for (let r of zoneColours){
          if (item.value >= r.min && item.value <= r.max){
            colour = r.colour;
          }
        }
      }
      item.colour = colour;

    }
    else {
      item.value = null;
      item.percentage = 0;
    }
    for (let item of s.values){
      values.push(item.value);
    }
    values = this.tidyHistory(values);
    item.values = values;
    item.loaded = true;
  }

  widgetDataLoadTimeout(){
    
  }

  tidyHistory(values: number[]) : number[]{
    if (values == null || values.length == 0){
      values = [];
    }
    while (values.length < this.history){
      values.unshift(0);
    }
    while (values.length > this.history){
      values.shift();
    }
    return values;
  }

  widgetDataAdded(s: SharedPoint) {
    
  }

  ngDoCheck() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }

  execute(ts){
    var action = ts.action;
    var siteUri = ts.siteUri;
    this.cmd.CommandRunCommand({customerId: this.dashboard.customerId,command: {siteUri: siteUri, action: action}}).subscribe(c => {
      this.toasterService.success("Command Issued");
    }, err => {
      this.toasterService.error("Command Not Issued");

    }
  );
  }

  executeButton(ts){
    var action = ts.buttonValue;
    var siteUri = ts.siteUri;
    this.cmd.CommandRunCommand({customerId: this.dashboard.customerId,command: {siteUri: siteUri, action: action}}).subscribe(c => {
      this.toasterService.success("Command Issued");
    }, err => {
      this.toasterService.error("Command Not Issued");
    }
  );
  }

  ptzCommands: string = "";
  ptzDirection: number = 0;
  ptzElevation: number = 0;
  ptzZoom: number = 1;

  control(ts, direction, distance){
    if (direction == "right"){
      var dir = this.ptzDirection + distance;
      while (dir > 359){
        dir = dir - 360;
      }
      this.ptzDirection = dir
    }
    if (direction == "left"){
      var dir2 = this.ptzDirection - distance;
      while (dir2 < 0){
        dir2 = dir2 + 360;
      }
      this.ptzDirection = dir2
    }
    if (direction == "up"){
      var zoom = this.ptzElevation + distance;
      this.ptzElevation = Math.min(90, zoom);
    }
    if (direction == "down"){
      var zoomDown = this.ptzElevation - distance;
      this.ptzElevation = Math.max(-90, zoomDown);
    }
    this.executeCameraEvent(ts);
  }

  zoom(ts, direction){
    if (direction == "in"){
      var zoom = this.ptzZoom + 1;
      this.ptzZoom = Math.min(47, zoom);
    }
    if (direction == "out"){
      var zoom = this.ptzZoom - 1;
      this.ptzZoom = Math.max(0, zoom);
    }
    this.executeCameraEvent(ts);
  }

  compass(ts, action){
    this.ptzZoom = 1;
    this.ptzElevation = 0
    if (action == "n"){
      this.ptzDirection = 0;
    }
    if (action == "ne"){
      this.ptzDirection = 45;
    }
    if (action == "e"){
      this.ptzDirection = 90;
    }
    if (action == "se"){
      this.ptzDirection = 135;
    }
    if (action == "s"){
      this.ptzDirection = 180;
    }
    if (action == "sw"){
      this.ptzDirection = 225;
    }
    if (action == "w"){
      this.ptzDirection = 270;
    }
    if (action == "nw"){
      this.ptzDirection = 315;
    }
    this.executeCameraEvent(ts);
  }

  debounceTimeout: any;
  executeCameraEvent(ts){
    if (this.debounceTimeout != null){
      clearTimeout(this.debounceTimeout)
    }
    this.debounceTimeout = setTimeout(() => {
      var siteUri = ts.siteUri;
      this.cmd.CommandRunCommand({
        customerId: this.dashboard.customerId,
        command: {
          siteUri: siteUri, 
          action: 'point', 
          parameters: [
            { parameterName:'zoom', parameterValue:this.ptzZoom.toString()},
            { parameterName:'direction', parameterValue:this.ptzDirection.toString()},
            { parameterName:'elevation', parameterValue:this.ptzElevation.toString()}
          ]
        }
      }).subscribe(c => {
        this.toasterService.success("PTZ Command Issued");
      }, err => {
        this.toasterService.error("Command Not Issued");
      });
    }, 500)
  }

  loadPtz(){
    var cookieCode = "d" + this.dashboard.dashboardId + "-coordinates";
    if (this.cookieService.check(cookieCode)){
      var coordinatesStr = this.cookieService.get("d" + this.dashboard.dashboardId + "-coordinates");
      if (coordinatesStr) {
        var coordinates = JSON.parse(coordinatesStr);
        this.ptzDirection = coordinates.direction;
        this.ptzElevation = coordinates.elevation;
        this.ptzZoom = coordinates.zoom;
      }
    }
  }

  savePtz(){
    var cookieCode = "d" + this.dashboard.dashboardId + "-coordinates";
    this.cookieService.set(cookieCode, JSON.stringify({
      direction: this.ptzDirection,
      elevation: this.ptzElevation,
      zoom: this.ptzZoom
    }));
  }

  preset(ts, action){ 
    var siteUri = ts.siteUri;
    this.cmd.CommandRunCommand({
      customerId: this.dashboard.customerId,
      command: {
        siteUri: siteUri, 
        action: 'preset', 
        parameters: [
          { parameterName:'action', parameterValue:action}
        ]
      }
    }).subscribe(c => {
      this.ptzCommands = this.ptzCommands + action.charAt(0);
    }, err => {
      this.toasterService.error("Command Not Issued");
    });
  }

  photo(ts){
    this.executeCameraEvent(ts);
  }

}
